import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import Tooltip from 'yoda-site-components/lib/components/YodaTooltip/YodaTooltip';
import { getPageURLFromAPIURL, updateQueryStringParameter, getScene7ImageURL } from '../../utils';
import * as styles from './VisualRelatedSearch.css';

const cx = classNames.bind(styles);

const getSearchLinks = (relatedSearchData) =>
    relatedSearchData.map((product) => {
        const { apiUrl = '', productImgId = '', text = '' } = product;
        const relatedSearchUrl = updateQueryStringParameter(
            getPageURLFromAPIURL(apiUrl),
            'searchType',
            'Related Search Term'
        );

        const visualSearchImage = [
            'block',
            'border-1',
            'border-gray-200',
            'border-solid',
            'h-11',
            'mx-auto',
            'my-0',
            'rounded-full',
            'w-11',
        ].join(' ');

        const searchProdName = [
            'font-open-sans',
            'mt-half',
            'no-underline',
            'searchProdName',
            'text-center',
            'text-gray-600',
            'text-small',
            'w-14',
            'whitespace-normal',
        ].join(' ');

        const linkWrapper = cx('linkWrapper', 'w-14');
        const searchLink = cx('block', 'no-underline', 'searchLink', 'text-small');

        return (
            <li className={linkWrapper} key={apiUrl}>
                <a href={relatedSearchUrl} className={searchLink}>
                    <img
                        alt={text}
                        className={visualSearchImage}
                        src={getScene7ImageURL(productImgId)}
                    />
                    {text.length > 28 ? (
                        <Tooltip
                            automationId="visual-related-search"
                            direction="Topright"
                            renderTooltipContents={text}
                            tooltipContentClass={cx('searchTooltipClass', 'bg-white-192')}
                            tooltipPlacement="Right"
                            triggerEventName="mouseover"
                        >
                            <h4 className={cx(searchProdName, 'searchTextEllipsis')}>{text}</h4>
                        </Tooltip>
                    ) : (
                        <h4 className={cx(searchProdName)}>{text}</h4>
                    )}
                </a>
            </li>
        );
    });

export const VisualRelatedSearch = () => {
    const {
        context: { deviceType: { isDesktop = true } = {} } = {},
        relatedSearchReducer = [],
    } = useSelector((store) => store);

    if (!(relatedSearchReducer || []).length) return null;

    const products = relatedSearchReducer.filter((product) => product.productImgId).splice(0, 7);

    return (
        <div className={cx('relatedSearchWrapper')} data-automation-id="releatedguides">
            <h3
                className={cx(
                    'font-open-sans-bold',
                    'mb-1',
                    'text-center',
                    'text-gray-600',
                    'text-medium'
                )}
            >
                Related To Your Search
            </h3>
            <div
                className={cx(
                    'border-1',
                    'border-gray-200',
                    'border-l-0',
                    'border-r-0',
                    'border-solid',
                    'mb-5',
                    'py-1',
                    'resultSet'
                )}
            >
                <div className={cx('resultSetBlock')}>
                    <ul
                        className={cx(
                            'inline-flex',
                            'justify-around',
                            'overflow-x-auto',
                            'scrolling-touch',
                            'searchLinks',
                            'w-full',
                            {
                                desktopLinks: isDesktop,
                            }
                        )}
                    >
                        {getSearchLinks(products)}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default VisualRelatedSearch;
